<template>
  <div id="title">
    <h1>{{ val }}</h1>
  </div>
</template>

<script>
  export default {
    name: 'Title',
    props: [ 'val' ]
  }
</script>

<style lang="scss" scoped>
  #title {
    h1 {
      background: $COLOR_PINK01;
      border-top: $COLOR_PINK02 toVW(5) solid;
      border-bottom: $COLOR_PINK02 toVW(5) solid;
      font-size: toVW(40);
      line-height: toVW(64);
      text-align: center;
      margin-bottom: toVW(10);
    }
  }
</style>
